import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

import AddNewButton from './AddNewButton'
import PageContent from './PageContent'
import PageHeader from './PageHeader'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import SimpleCrudsTemplate from '../../../components/templates/v2/SimpleCrudsTemplate'
import useRouteParams from '../../../utils/routes/helpers/useParam'

const MinicrudsListPage = () => {
  const entity = useRouteParams('entity')

  return (
    <SimpleCrudsTemplate>
      <FilterHandler initialState={{ entity }}>
        <PageHeader />
        <PageContent />
      </FilterHandler>
      <AddNewButton />
      <Separator weight={90} />
    </SimpleCrudsTemplate>
  )
}

export default MinicrudsListPage
